import React, { useEffect, useState } from "react";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../../../components/BuilderComponents/TableTreeModal";
import Input from "../../../../components/FormComponents/Input";
import SingleSelectBox from "../../../../components/FormComponents/SingleSelectBox";
import MultiSelectBox from "../../../../components/FormComponents/MultiSelectBox";

const CalendarFilter = ({ tableRef, currentSmLookup }) => {
  const { currentBlockConfig, setCurrentBlockConfig } = useAppBlocksContext();
  const [fieldListOfLookup, setFieldListOfLookup] = useState([]);

  const { data: newData, table_id } = currentBlockConfig;
  const [isFieldModalOpen, setIsFieldModalOpen] = useState("");

  const deleteField = (field) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data[field] = "";
    setCurrentBlockConfig(newcalendarConfig);
  };
  const selectFieldCallbackFunction = (data) => {
    const newcalendarConfig = { ...currentBlockConfig };
    const { id, type, field_type, display } = data;
    newcalendarConfig.data[isFieldModalOpen] = { id, type, field_type, display };

    // if filter type is not entity
    if (currentBlockConfig.data.filter_type === "entity") {
      // make a filter field array without subject field
      filterFieldsForLookup(data.id.split(".")[1]);

      // remove this subject field if inside a current subject filters
      const newFilters = newcalendarConfig.data.subject_filter.filters.filter(
        (field) => field.id !== data.id.split(".")[1]
      );
      newcalendarConfig.data.subject_filter.filters = newFilters;
    }

    setCurrentBlockConfig(newcalendarConfig);
    setIsFieldModalOpen("");
  };
  const handleCheckboxChange = (fieldIndex, isChecked) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data.subject_filter.filters[fieldIndex].is_multiselect = isChecked;
    setCurrentBlockConfig(newcalendarConfig);
  };

  const handleLookupChange = (name, value) => {
    // const { name, value } = e.target;
    const newcalendarConfig = { ...currentBlockConfig };
    const obj = {
      lookup_id: value,
      filters: []
    };
    newcalendarConfig.data[name] = obj;
    newcalendarConfig.data["subject_field"] = { id: "", type: "", field_type: "", display: "" };
    setCurrentBlockConfig(newcalendarConfig);
    // filterLookup(name, value);
  };

  const filterFieldsForLookup = (subjectFieldId) => {
    const fieldList = [];
    currentSmLookup[currentBlockConfig.data.subject_filter.lookup_id].sub_fields.forEach((element) => {
      const { id, type, field_type, display } = element;
      const consideringField = ["textfield", "select", "radio", "email", "checkbox", "learning-text"];
      if (consideringField.includes(field_type) && id !== subjectFieldId) {
        fieldList.push({ id, type, field_type, display, is_multiselect: false });
      }
    });
    setFieldListOfLookup(fieldList);
  };

  const handleChangeData = (name, value) => {
    const newcalendarConfig = { ...currentBlockConfig };
    // const { name, value } = e.target;

    // every change need to remove current filter configuration
    const obj = {
      lookup_id: "",
      filters: []
    };
    newcalendarConfig.data["subject_filter"] = obj;
    newcalendarConfig.data["subject_field"] = { id: "", type: "", field_type: "", display: "" };

    newcalendarConfig.data[name] = value;
    setCurrentBlockConfig(newcalendarConfig);
  };

  const handleMultiselectField = (data) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data.subject_filter.filters = data;
    setCurrentBlockConfig(newcalendarConfig);
  };

  const handleChangeShowSubjectFilter = (e) => {
    const newcalendarConfig = { ...currentBlockConfig };
    newcalendarConfig.data.subject_field.show_subject_filter = e.target.checked;
    setCurrentBlockConfig(newcalendarConfig);
  };

  useEffect(() => {
    const lookupId = currentBlockConfig.data.subject_filter?.lookup_id || "";
    if (!lookupId) return;
    filterFieldsForLookup(currentBlockConfig.data["subject_field"].id.split(".")[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const filterOptions = [
    {
      id: "entity",
      name: "Entity"
    },
    {
      id: "user",
      name: "User"
    }
  ];
  const folderIds = currentBlockConfig.data.subject_filter?.lookup_id
    ? [currentBlockConfig.data.subject_filter?.lookup_id]
    : [];
  return (
    <>
      <div className="builder_form p_3">
        <Input
          type="checkbox"
          label="Show Subject Filter"
          checked={currentBlockConfig.data.subject_field?.show_subject_filter}
          onChange={handleChangeShowSubjectFilter}
        />
        <SingleSelectBox
          selectedData={currentBlockConfig.data.filter_type || "entity"}
          options={filterOptions}
          onChange={(obj) => handleChangeData("filter_type", obj.id)}
          placeholder="Select Filter type"
          label="Select Filter type"
        />
        {currentBlockConfig.data.filter_type === "entity" && (
          <SingleSelectBox
            selectedData={currentBlockConfig.data.subject_filter?.lookup_id || ""}
            options={Object.values(currentSmLookup)}
            onChange={(obj) => handleLookupChange("subject_filter", obj.id)}
            labelKey={["display"]}
            placeholder="Select Subject Lookup"
            label="Select Filter type"
          />
        )}
        {(currentBlockConfig.data.subject_filter?.lookup_id || currentBlockConfig.data.filter_type === "user") && (
          <>
            <label className="builder_label">Subject Field</label>
            <div className="d_flex g_8 justify_between align_center">
              <div className="builder_input w_100" onClick={() => setIsFieldModalOpen("subject_field")}>
                {tableRef.current[newData["subject_field"].id]?.display || "Select field "}
              </div>
              {tableRef.current[newData["subject_field"].id]?.display && (
                <ButtonActionIcon size="xsm" type="delete" onClick={() => deleteField("subject_field")} />
              )}
            </div>
          </>
        )}
        {currentBlockConfig.data["subject_field"].id && (
          <>
            {currentBlockConfig.data.subject_filter?.lookup_id && (
              <>
                <MultiSelectBox
                  options={fieldListOfLookup}
                  selectedData={currentBlockConfig.data.subject_filter?.filters || []}
                  onChange={handleMultiselectField}
                  labelKey="display"
                  label="Select Subject Filter"
                />
              </>
            )}
            {currentBlockConfig.data.subject_filter?.filters &&
              currentBlockConfig.data.subject_filter?.filters.map((field, index) => (
                <div className="d_flex g_8" key={field.id}>
                  <div>{field.display}</div>
                  <div className="d_flex g_4 align_center">
                    <Input
                      type="checkbox"
                      checked={field.is_multiselect || false}
                      onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                    />
                    <label className="builder_label mb_0">Is Multiselect?</label>
                  </div>
                </div>
              ))}
          </>
        )}
      </div>
      <BuilderModal isOpen={isFieldModalOpen} onClose={() => setIsFieldModalOpen("")} modalName="Select Field">
        <TableTreeModal
          callbackFunction={selectFieldCallbackFunction}
          tableId={table_id}
          folderId={folderIds}
          selectedFile={currentBlockConfig?.data?.subject_field?.id}
        />
      </BuilderModal>
    </>
  );
};

export default CalendarFilter;
